import SyncReportTable from './SyncReportTable';

export default SyncReportTable;
